import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn, inputCls } from "./ui";

export const DeleteClientDialog = ({ c, onClose, onDeleted }) => {
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await api.post(`/clients/${c.id}/delete`, { confirm: typed });
      toast.success(`${c.panel_user} deletado do SYSLOG e do CRM`);
      onDeleted();
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao deletar"); }
    setBusy(false);
  };
  return (
    <Modal testid="delete-client-dialog" title="Deletar cliente" onClose={onClose}>
      <p className="text-sm text-slate-300">Apaga <b>{c.name || c.panel_user}</b> no SYSLOG e no CRM. Não dá para desfazer, e fica registrado quem deletou.</p>
      <p className="mt-3 text-xs text-slate-400">Para confirmar, digite o usuário: <span className="font-mono text-rose-300">{c.panel_user}</span></p>
      <input data-testid="delete-client-confirm-input" value={typed} onChange={(e) => setTyped(e.target.value)} className={`${inputCls} mt-2`} autoComplete="off" />
      <div className="mt-5 flex justify-end gap-2">
        <Btn tone="ghost" onClick={onClose}>Cancelar</Btn>
        <button data-testid="delete-client-confirm-btn" disabled={busy || typed.trim() !== c.panel_user} onClick={go}
          className="rounded-lg bg-rose-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-rose-600 disabled:opacity-40">Deletar de vez</button>
      </div>
    </Modal>
  );
};
